module.exports = __webpack_public_path__ + "static/media/ams-success-purplish-blue.6626cb18.gif";